


















export default {
  name: 'ProductTileLayout',
}
